import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getSeoData } from '../../utils/SeoConfig';

const SeoHelmet = ({ titleCn, titleEn, lang, extraKeywords = [] }) => {
  const seoData = getSeoData(titleCn, titleEn, lang);
  
  // Merge extra keywords if provided
  let keywords = seoData.keywords;
  if (extraKeywords && extraKeywords.length > 0) {
      keywords = `${extraKeywords.join(", ")}, ${keywords}`;
  }

  return (
    <Helmet>
      <title>{seoData.title}</title>
      <meta name="keywords" content={keywords} />
      <meta name="description" content={seoData.description} />
    </Helmet>
  );
};

export default SeoHelmet;
